import React, { useEffect, useState } from 'react';
import { Collapse, Chip, Typography } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    chip: {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        '& .MuiChip-icon': {
            color: theme.palette.primary.main,
        },
        '& .MuiChip-label': {
            color: theme.palette.primary.main,
        },
    },
}));

const CollapsibleComponent = ({ children, title, buttonText, collapsTrigger, underLineVisible = true }) => {
    const [open, setOpen] = useState(false);
    const classes = useStyles();

    const handleToggle = () => {
        setOpen(!open);
    };

    useEffect(() => {

        setOpen(collapsTrigger);

    }, [collapsTrigger])

    return (
        <div className='w-full'>
            <div className='w-full flex justify-between'>
                <Typography variant="h6" className="font-semibold">
                    {title}
                </Typography>
                <Chip
                    label={buttonText}
                    onClick={handleToggle}
                    icon={open ? <ExpandLess /> : <ExpandMore />}
                    variant="outlined"
                    size='medium'
                    className={classes.chip}
                />
            </div>
            {underLineVisible &&
                < div className="w-full main-title-underline"></div>
            }
            <Collapse in={open}>
                <div>
                    {children}
                </div>
                <div className="w-full main-title-underline mt-10"></div>
            </Collapse>
        </div >
    );
};

export default CollapsibleComponent;
